import { DateTime } from "luxon"

export const parseDate = (timestamp: string) => {
    if (!timestamp || timestamp.length === 0) return ""
    return DateTime.fromISO(timestamp).toFormat("MM/dd/yyyy")
}
